import React, { Component } from 'react';
import {
    Box,
    FormControlLabel,
    Radio,
    RadioGroup,
} from '@mui/material';

export class RadioButtonGroup extends Component {
    render() {
        const { items = [], selectedKey, onSelect, style } = this.props;

        return (
            <Box
                sx={{
                    border: '1px solid #EAEAEA',
                    backgroundColor: '#F1F1F1',
                    borderRadius: '6px',
                    minHeight: 56,
                    display: 'flex',
                    px: 1.5,
                    ...style,
                }}
            >
                <RadioGroup
                    row
                    value={selectedKey ?? ''}
                    onChange={(e) => onSelect?.(e.target.value)}
                    sx={{
                        width: '100%',
                    }}
                >
                    {items.map((item) => (
                        <FormControlLabel
                            key={item.key}
                            value={item.key}
                            control={
                                <Radio
                                    sx={{
                                        color: '#222',
                                        '&.Mui-checked': {
                                            color: '#111',
                                        },
                                    }}
                                />
                            }
                            label={item.label}
                            sx={{
                                flex: 1,
                                margin: 0,
                                // justifyContent: 'center',
                                '& .MuiFormControlLabel-label': {
                                    fontSize: 14,
                                },
                            }}
                        />
                    ))}
                </RadioGroup>
            </Box>
        );
    }
}

export default RadioButtonGroup;